import { CLIENT_CUSTOMER_ADDRESS_API } from "shared/constants/api-endpoint";
import { apiClient } from "shared/plugins/http-service";
import { ICreatedCustomerAddressModel, ICustomerAddressModel } from "./customer-address.models";

export const getCustomerAddressesAPI = async () => {
  return await apiClient.getHttp<ICustomerAddressModel[]>(
    `${CLIENT_CUSTOMER_ADDRESS_API}`
  );
};

export const getCustomerAddressAPI = async (id: number) => {
  return await apiClient.getHttp<ICustomerAddressModel>(
    `${CLIENT_CUSTOMER_ADDRESS_API}/${id}`
  );
};

export const createdCustomerAddressesAPI = async (model: ICreatedCustomerAddressModel) => {
  return await apiClient.postHttp<number>(
    `${CLIENT_CUSTOMER_ADDRESS_API}`, model
  );
};

export const updatedCustomerAddressesAPI = async (model: ICreatedCustomerAddressModel) => {
  return await apiClient.putHttp(
    `${CLIENT_CUSTOMER_ADDRESS_API}`, model
  );
};

export const removedCustomerAddressesAPI = async (id: number) => {
  return await apiClient.deleteHttp(
    `${CLIENT_CUSTOMER_ADDRESS_API}/${id}`
  );
};


